import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { getSessionId } from '../../helpers/storageUtils';
import { Ciudades } from '../../Models/ciudades';
import { Paises } from '../../Models/paises';
import { TokenService } from '../../shared/services/token.service';
import { UtilsService } from '../utils.service';

@Injectable({
  providedIn: 'root',
})
export class CiudadesService {
  tokenService = inject(TokenService);
  baseUri = environment.URL_CIUDADES;
  baseUriPaises = environment.URL_PAISES;
  GENERAL_CLIENT_ID = environment.GENERAL_CLIENT_ID;
  SESSION_ID = getSessionId().toString();
  private http = inject(HttpClient);
  private utils = inject(UtilsService);

  constructor() {}

  public getCiudades(sessionId: string): Observable<Ciudades> {
    const headers = this.utils.getHeaders(sessionId || this.SESSION_ID);

    return this.http.get<Ciudades>(this.baseUri, { headers: headers });
  }

  public getPaises(sessionId: string): Observable<Paises> {
    const headers = this.utils.getHeaders(sessionId || this.SESSION_ID);
    return this.http.get<Paises>(this.baseUriPaises, { headers: headers });
  }
}
